export const dummyPrivacy = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Pediatric Wellness Zone - Privacy Policy</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            background-color: #fff;
            margin: 0;
            padding: 20px;
            color:black
        }
        h1, h2, h3 {
            color: #000; /* Black color for headings */
            font-weight: bold; /* Bold headings */
        }
        h1 {
            font-size: 24px;
            margin-bottom: 10px;
        }
        h2 {
            font-size: 18px;
            margin-top: 20px;
            margin-bottom: 10px;
        }
        h3 {
            font-size: 16px;
            margin-top: 15px;
            margin-bottom: 8px;
        }
        p, ul, li {
            font-size: 14px;
        }
        strong {
            font-weight: bold;
        }
        hr {
            border: 1px solid #ccc; /* Gray line */
            margin: 20px 0;
        }
        ul {
            list-style-type: disc;
            margin-left: 20px;
            margin-bottom: 15px;
        }
        li {
            margin-bottom: 5px;
        }
        a {
            color: #007BFF; /* Blue color for links */
            text-decoration: none;
        }
        a:hover {
            text-decoration: underline;
        }
    </style>
</head>
<body>
    <h1>Pediatric Wellness Zone - Privacy Policy</h1>
    <p><strong>Effective Date:</strong> April 10, 2025</p>
    <p>These Privacy Policy describes how Pediatric Wellness Zone ("we", "us", or "our") collects, uses, and discloses your personal information when you use our mobile application ("App") and related services. By accessing or using our App, you agree to the terms of this Privacy Policy.</p>
    <hr />
    <h2>1. Information We Collect</h2>
    <h3>1.1. Information You Provide</h3>
    <p>We may collect personal information you voluntarily provide to us, including your name, email address, demographic data, health-related data, and any other details you choose to submit.</p>
    <h3>1.2. Automatically Collected Information</h3>
    <p>We may automatically collect certain information about your device and usage of the App, including your IP address, device type, operating system, actions taken in the App, and other analytical data.</p>
    <h3>1.3. AI Chat Bot Interaction</h3>
    <p>We may collect interactions with our AI chatbot, including questions asked and responses given, to improve its accuracy and usefulness.</p>
    <hr />
    <h2>2. Use of Information</h2>
    <h3>2.1.</h3>
    <p>We may use your information to:</p>
    <ul>
        <li>Provide and maintain functionality of the App;</li>
        <li>Respond to inquiries and provide customer support;</li>
        <li>Personalize your experience and improve services;</li>
        <li>Analyze trends and improve App performance;</li>
        <li>Communicate about updates, promotions, or relevant information;</li>
        <li>Comply with legal obligations, including HIPAA where applicable.</li>
    </ul>
    <h3>2.2.</h3>
    <p>AI Chat Bot interactions may be reviewed to enhance user support, while not replacing medical or professional advice.</p>
    <hr />
    <h2>3. HIPAA Compliance</h2>
    <p>We understand that some of the data collected may be protected health information (PHI) as defined by the Health Insurance Portability and Accountability Act of 1996 (HIPAA). We are committed to maintaining the privacy and security of PHI and implement safeguards to protect this information. All third-party service providers who may access PHI are required to sign Business Associate Agreements (BAAs) and adhere to HIPAA standards.</p>
    <hr />
    <h2>4. Disclosure of Information</h2>
    <h3>4.1.</h3>
    <p>We may disclose personal information:</p>
    <ul>
        <li>With your consent;</li>
        <li>To comply with laws, regulations, or legal processes;</li>
        <li>To service providers who operate under strict confidentiality agreements and, where appropriate, HIPAA-compliant BAAs;</li>
        <li>To enforce our rights and policies.</li>
    </ul>
    <h3>4.2.</h3>
    <p>We may also share anonymized or aggregated information for research or analytics.</p>
    <hr />
    <h2>5. Data Security and Retention</h2>
    <p>We take reasonable physical, administrative, and technical safeguards to protect your personal information from unauthorized access, disclosure, or misuse. Despite these efforts, no method of electronic storage or transmission is 100% secure.</p>
    <p>We retain your information for as long as necessary to provide services, comply with legal obligations, resolve disputes, and enforce our agreements.</p>
    <hr />
    <h2>6. Children's Privacy</h2>
    <p>Our App is not intended for children under 13. We do not knowingly collect personal information from children without verified parental consent. If we learn that a child under 13 has provided us with personal information, we will delete it.</p>
    <hr />
    <h2>7. Your Rights</h2>
    <p>You may have rights to access, correct, or delete your personal information. If you wish to exercise these rights, please contact us at <a href="mailto:support@pediatricwellnesszone.com">support@pediatricwellnesszone.com</a>.</p>
    <hr />
    <h2>8. Changes to this Privacy Policy</h2>
    <p>We may update this Privacy Policy at any time. Changes become effective upon posting. Continued use of the App signifies your acceptance.</p>
    <hr />
    <h2>9. Contact Us</h2>
    <p>If you have any questions about this Privacy Policy, please contact us at: <a href="mailto:support@pediatricwellnesszone.com">support@pediatricwellnesszone.com</a></p>
    <p><strong>Last updated:</strong> 4/10/2025</p>
</body>
</html>`

export const dummyTermCondition = `<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8">
    <title>Pediatric Wellness Zone - Terms and Conditions</title>
    <style>
        body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            background-color: #fff;
            margin: 0;
            padding: 20px;
        }
        h1, h2 {
            color: #000; /* Black color for headings */
            font-weight: bold; /* Bold headings */
        }
        h1 {
            font-size: 24px;
            margin-bottom: 10px;
        }
        h2 {
            font-size: 18px;
            margin-top: 20px;
            margin-bottom: 10px;
        }
        p, ul, li {
            font-size: 14px;
        }
        strong {
            font-weight: bold;
        }
        hr {
            border: 1px solid #ccc; /* Gray line */
            margin: 20px 0;
        }
        ul {
            list-style-type: disc;
            margin-left: 20px;
            margin-bottom: 15px;
        }
        li {
            margin-bottom: 5px;
        }
        a {
            color: #007BFF; /* Blue color for links */
            text-decoration: none;
        }
        a:hover {
            text-decoration: underline;
        }
    </style>
</head>
<body>
    <h1>Pediatric Wellness Zone - Terms and Conditions</h1>
    <p><strong>Effective Date:</strong> April 10, 2025</p>
    <p>These Terms and Conditions ("Terms") are an agreement between you ("User") and Pediatric Wellness Zone ("Company"). They govern your access and use of the Pediatric Wellness Zone App and related services (collectively, "App").</p>
    <hr />
    <h2>1. Acceptance of Terms</h2>
    <p>By downloading, installing, or using the App, you agree to these Terms. If you do not agree, you may not use the App.</p>
    <hr />
    <h2>2. Age Requirement</h2>
    <p>You must be at least 18 years old to use this App. If under 18, you may only use it with the involvement of a parent or legal guardian.</p>
    <hr />
    <h2>3. Account Registration</h2>
    <p>To access some features, you may need to register. You agree to provide accurate information and maintain the security of your account credentials.</p>
    <hr />
    <h2>4. User Content</h2>
    <p>You are responsible for content you submit. You retain ownership but grant us a license to use, reproduce, and display your content within the App. We act only as a passive conduit and are not responsible for user-generated content.</p>
    <hr />
    <h2>5. AI Chat Bot Disclaimer</h2>
    <p>Our AI chatbot offers general health-related guidance. It is not a substitute for professional medical advice. Always consult a qualified health provider with questions. We are not liable for any harm arising from chatbot use.</p>
    <hr />
    <h2>6. Medical Disclaimer</h2>
    <p>Information provided via the App, including the AI chatbot, is for educational purposes only and not medical advice. Do not disregard medical guidance due to something you read or receive from the App.</p>
    <hr />
    <h2>7. Prohibited Activities</h2>
    <p>You agree not to:</p>
    <ul>
        <li>Copy, scrape, or distribute any part of the App;</li>
        <li>Use bots or automated systems to access the App;</li>
        <li>Send spam or unsolicited messages;</li>
        <li>Upload viruses or harmful software;</li>
        <li>Attempt unauthorized access to the App;</li>
        <li>Collect personal information from others;</li>
        <li>Use the App for unlawful purposes.</li>
    </ul>
    <hr />
    <h2>8. Intellectual Property</h2>
    <p>All App content (excluding User Content) is our property or licensed to us and protected by law. You may not use our name, logo, or branding without written consent.</p>
    <hr />
    <h2>9. HIPAA Compliance</h2>
    <p>To the extent that the App handles Protected Health Information (PHI), we comply with HIPAA standards. We implement appropriate administrative, technical, and physical safeguards and ensure our service providers do the same via Business Associate Agreements.</p>
    <hr />
    <h2>10. Indemnification</h2>
    <p>You agree to indemnify and hold harmless Pediatric Wellness Zone and affiliates from any claims arising out of your use of the App or breach of these Terms.</p>
    <hr />
    <h2>11. Limitation of Liability</h2>
    <p>We are not liable for any indirect, incidental, or consequential damages, including loss of data or profits, resulting from use or inability to use the App.</p>
    <hr />
    <h2>12. Termination</h2>
    <p>We may suspend or terminate your access to the App without notice for conduct that we believe violates these Terms or is harmful to other users.</p>
    <hr />
    <h2>13. Governing Law</h2>
    <p>These Terms are governed by the laws of the State of Georgia, USA, without regard to conflict of law principles.</p>
    <hr />
    <h2>14. Entire Agreement</h2>
    <p>These Terms constitute the entire agreement between you and us regarding the App.</p>
    <hr />
    <h2>15. Severability</h2>
    <p>If any part of these Terms is deemed invalid, the remainder shall remain in effect.</p>
    <hr />
    <h2>16. Changes to Terms</h2>
    <p>We reserve the right to modify these Terms at any time. Changes are effective upon posting. Continued use indicates acceptance.</p>
    <hr />
    <h2>17. Contact Information</h2>
    <p>For questions, contact: <a href="mailto:support@pediatricwellnesszone.com">support@pediatricwellnesszone.com</a></p>
    <p><strong>Last updated:</strong> 4/10/2025</p>
</body>
</html>`